import { render } from "./LUserLink.vue?vue&type=template&id=50727984&scoped=true&ts=true"
import script from "./LUserLink.vue?vue&type=script&lang=ts"
export * from "./LUserLink.vue?vue&type=script&lang=ts"

import "./LUserLink.vue?vue&type=style&index=0&id=50727984&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50727984"]])

export default __exports__